import axios from 'axios'
import { toastr } from 'react-redux-toastr'
import { URL } from '../../assets/js/constants'

export function carregarEndereco(data) {
    return {
        type: 'ENDERECO_FETCHED',
        payload: data
    }
}

export function carregarEnderecos(data) {
    return {
        type: 'ENDERECOS_FETCHED',
        payload: data
    }
}

export function getEndereco(idEndereco) {
    return dispatch => {
        axios.get(`${URL}/enderecos/endereco-do-usuario/${idEndereco}`)
            .then(resp => dispatch(carregarEndereco(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}

export function getEnderecosDoUsuario(idUsuario) {
    return dispatch => {
        axios.get(`${URL}/enderecos/usuario/${idUsuario}`)
            .then(resp => dispatch(carregarEnderecos(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}

export function getEnderecosDoNegocio(idNegocio) {
    return dispatch => {
        axios.get(`${URL}/enderecos/negocio/${idNegocio}`)
            .then(resp => dispatch(carregarEnderecos(resp.data)))
            .catch(e => toastr.error('Erro', e.message))
    }
}

export function addEndereco(values) {
    return dispatch => {
        axios.post(`${URL}/enderecos`, values)
            .then(_ => toastr.success('Sucesso', 'Endereço cadastrado com sucesso.'))
            .catch(e => {
                try {
                    const data = e.response.data;
                    if (typeof data !== 'undefined') {
                        const { status, msg, errors } = data;
                        if (status === 400) {
                            errors.forEach(erro => {
                                toastr.error(msg, 'Campo: ' + erro.fieldName + '. ' + erro.message);
                            })
                        } else {
                            toastr.error(msg, 'Erro: ' + status);
                        }
                    }
                } catch (e) {
                    return false;
                }
            })
    }
}

export async function buscarEnderecoCEP(cep) {
    const url = `https://viacep.com.br/ws/${cep}/json/`;
    try {
        const response = await axios.get(url);
        return response.data;
    } catch (e) {
        toastr.error('Erro', e);
        return null
    }
}